// Canonical 8-stage ROADRIG journey — the single source of truth used by
// the homepage Development Tracker and the journey indicator on every
// Journal page. Stages with a journal slug deep-link to the matching entry.

export const JOURNEY_STAGES = [
  { idx: 1, key: "idea",         shortLabel: "The Idea",         trackerLabel: "Concept Complete",          slug: "idea",         status: "done" },
  { idx: 2, key: "sketches",     shortLabel: "Sketches",         trackerLabel: "Sketches Complete",         slug: "sketches",     status: "done" },
  { idx: 3, key: "design",       shortLabel: "Design",           trackerLabel: "Design Complete",           slug: "design",       status: "done" },
  { idx: 4, key: "tech-pack",    shortLabel: "Tech Pack",        trackerLabel: "Tech Pack & Factory Partner",slug: "factory",     status: "done" },
  { idx: 5, key: "prototype",    shortLabel: "Prototype V1",     trackerLabel: "Prototype V1 In Development",slug: "prototype",    status: "active" },
  { idx: 6, key: "road-testing", shortLabel: "Road Testing",     trackerLabel: "Road Testing",              slug: "road-testing", status: "pending" },
  { idx: 7, key: "production",   shortLabel: "Production",       trackerLabel: "Production",                slug: null,           status: "pending" },
  { idx: 8, key: "launch",       shortLabel: "Launch",           trackerLabel: "Public Launch",             slug: null,           status: "pending" },
];

export const TOTAL_STAGES = JOURNEY_STAGES.length;

export const findStageBySlug = (slug) =>
  JOURNEY_STAGES.find((s) => s.slug === slug) || null;

const completedCount = JOURNEY_STAGES.filter((s) => s.status === "done").length;
export const PROGRESS_PERCENT = Math.round(((completedCount + 0.5) / TOTAL_STAGES) * 100);
